export default __webpack_public_path__ + "static/governance-submenu-64a55bcecffece60fc8513529fda6963.png";